/**
 * Разговоры без метки.
 *
 * Дозвон был, результат не записан — такие назначения не возвращаются в круг,
 * а остаются у того же диспетчера и всплывают первыми при входе на пульт (§6.6).
 * Каждая строка здесь — потенциально потерянный лид, поэтому блок стоит выше очереди
 * и не сворачивается.
 */

import type { DeskAssignment } from '@cc/shared';

import { Button } from '../../shared/ui/button.js';
import { formatPhone } from '../../shared/lib/format-phone.js';
import { formatDateTimeMsk } from '../../shared/lib/msk.js';

export interface NeedsLabelProps {
  assignments: DeskAssignment[];
  onOpen: (assignment: DeskAssignment) => void;
}

export function NeedsLabel({ assignments, onOpen }: NeedsLabelProps): React.JSX.Element | null {
  if (assignments.length === 0) return null;

  return (
    <section className="rounded-2xl border border-amber-300 bg-amber-50 p-4">
      <h2 className="text-base font-medium text-slate-900">
        Разговор был, метки нет — {assignments.length}
      </h2>
      <p className="mt-1 text-sm text-slate-700">
        Пока метка не проставлена, контакт не уйдёт в следующий круг.
      </p>
      <ul className="mt-3 flex flex-col gap-2">
        {assignments.map((assignment) => (
          <li key={assignment.id} className="flex items-center gap-4">
            <span className="tabular-nums text-slate-900">{formatPhone(assignment.phone)}</span>
            <span className="text-sm text-slate-600">
              {formatDateTimeMsk(assignment.assignedAt)}
            </span>
            <Button
              variant="primary"
              className="ml-auto"
              onClick={() => { onOpen(assignment); }}
            >
              Поставить метку
            </Button>
          </li>
        ))}
      </ul>
    </section>
  );
}
